/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_OpenintabInputs */

const en_enum_custom_property_link_rule_type_openintab = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_OpenintabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Openintab`)
};

const de_enum_custom_property_link_rule_type_openintab = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_OpenintabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In neuem Tab öffnen`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Openintab" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_OpenintabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_openintab = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_OpenintabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_OpenintabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_openintab(inputs)
	return de_enum_custom_property_link_rule_type_openintab(inputs)
});